import { configureStore } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";
import listingDetail from "./listingDetail";
import listingSearch from "./listingSearch";
import favorite from "./favorite";
import stickyInfoBar from "./stickyInfoBar";
import signup from "./signup";
import auth from "./auth";
import creditCalculation from "./creditCalculation";
import filter from "./filter";
import hoveredListing from "./hoveredListing";

const makeStore = () =>
  configureStore({
    reducer: {
      listingDetail,
      favorite,
      stickyInfoBar,
      signup,
      creditCalculation,
      listingSearch,
      auth,
      filter,
      hoveredListing,
    },
    devTools: true,
  });

export const store = makeStore();

export const wrapper = createWrapper(makeStore);
